/**
 * Statuses of form submit
 */
module.exports = {
  accepted: 'accepted',
  redirected: 'redirected',
  rejected: 'rejected',
  serverError: 'serverError',
};
